import React, { useEffect, useState } from "react";
import styles from "./basicKyc.module.css";
import { Box, Grid2, Typography } from "@mui/material";
import config from "../../../config/config";
import store from "../../../Store/Store";
import { observer } from "mobx-react";

const BasicKyc = observer(({ companyId }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(false);
    const [kycCompanyId, setKycCompanyId] = useState(companyId);
  let tokens = localStorage.getItem("authToken");
  let parsedTokens = JSON.parse(tokens);

  // let kycCompanyId = "2bb15d24-8730-465a-a725-6b128f1a3f92";
  useEffect(() => {
    setKycCompanyId(store.KycCompanyId ? store.KycCompanyId : companyId);
  }, []);
  useEffect(() => {
    let abort = false;

    async function fetchKyc() {
      // if (!kycCompanyId) {
      //   setErr("Missing user_id");
      //   setLoading(false);
      //   return;
      // }

      try {
        setLoading(true);
        setErr("");

        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        const res = await fetch(
          `${config.kyc_api_endpoint}/basic-kyc/by-company`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedTokens.IdToken,
              aws_cognito_access_token: parsedTokens.AccessToken,
            },
            // headers: {
            //   aws_cognito_id_token: parsedTokens.IdToken,
            //   aws_cognito_access_token: parsedTokens.AccessToken,
            //   "Content-Type": "application/json",
            // },
            // body: JSON.stringify({ company_id: kycCompanyId }),
            body: JSON.stringify({
              company_id: kycCompanyId,
            }),
          }
        );

        const json = await res.json().catch(() => ({}));
        if (!res.ok || json?.success === false) {
          throw new Error(json?.message || `Request failed with ${res.status}`);
        }

        if (abort) return;

        const d = json?.data || {};
        // store.setCompanyName(d.Company_Name);
        store.setEntityType(d.Business_Entity_Type);
        setData({
          name: d.Name ?? null,
          phone_number: d.Ph_Number ?? null,
          email: d.Email ?? null,
          gstin: d.GSTIN ?? null,
          entity_type: d.Business_Entity_Type ?? null,
          company_name: d.Company_Name ?? null,
          pan:
            d?.PAN?.toUpperCase() ||
            ((d?.gstin || d?.GSTIN) &&
            String(d.gstin ?? d.GSTIN)
              .trim()
              .toUpperCase().length >= 15
              ? String(d.gstin ?? d.GSTIN)
                  .trim()
                  .toUpperCase()
                  .slice(2, -3)
              : null),
          cin: d.CIN ?? null,
          registered_address: d.Registered_Address ?? null,
        });
      } catch (e) {
        if (!abort) setErr(e?.message || "Failed to load KYC data");
      } finally {
        if (!abort) setLoading(false);
      }
    }

    fetchKyc();
    return () => {
      abort = true;
    };
  }, [kycCompanyId,store.refresh]);

  return (
    <div className={`${styles.wrapper} container`}>
      <div className={styles.title}>Point of Contact Information</div>
      <hr />
      <div>
        <Grid2 spacing={0.5} sx={{ mb: 2, mt: 2 }}>
          <DetailRow label="Name" value={data.name} />
          <DetailRow label="Phone no" value={data.phone_number} />
          <DetailRow label="Email ID" value={data.email} />
        </Grid2>
      </div>
      <div></div>
      <div className={styles.title}>Business Identification</div>
      <hr />
      <div>
        <Grid2 spacing={0.5} sx={{ mb: 2, mt: 2 }}>
          {data?.gstin?.length > 0 && (
            <DetailRow label="GSTIN" value={data.gstin} />
          )}
          <DetailRow label="Business Entity Type" value={data.entity_type} />
          <DetailRow label="Company Name" value={data.company_name} />
          <DetailRow label="PAN" value={data.pan} />
          {data?.cin?.length > 0 && <DetailRow label="CIN" value={data.cin} />}
          <DetailRow
            label="Registered Address"
            value={data.registered_address}
          />
        </Grid2>
      </div>
    </div>
  );
});

export default BasicKyc;

function DetailRow({ label, value }) {
  return (
    <Grid2 item xs={12} sm={12} md={12}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "120px 8px 1fr", sm: "150px 8px 1fr" },
          alignItems: "baseline",
          columnGap: 1,
          py: 2,
        }}
      >
        <Typography
          variant="body1"
          sx={{ color: "#4C4E64", fontWeight: 600, whiteSpace: "nowrap" }}
        >
          {label}
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "#4C4E64", fontWeight: 600, whiteSpace: "nowrap" }}
        >
          :
        </Typography>
        <Typography
          variant="body1"
          // sx={{ color: "#4C4E64", fontWeight: 600, whiteSpace: "nowrap" }}
        >
          {value}
        </Typography>
      </Box>
    </Grid2>
  );
}
